// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import '../../pages/cashierMenu.css';
// import ApiService from '../../../services/apiService';
// import { toast } from 'react-toastify';
// import { connect } from 'react-redux';
// import userManagement from '../../../services/userManagement';
// import moment from 'moment';
// import { useSelector } from 'react-redux';
// import { getUserId, getUserName } from '../../../../Redux/selecters';
// import Select from 'react-select';
// import { useDispatch } from 'react-redux';
// import { logout } from '../../../../Redux/actions';
// import { CashEnums } from '../../../../Enums/config';
// import { generateUniqueVoucherNumber } from '../.../../../../services/globalService';
// const DayCloseForm = ({ Currency }) => {
//   let navigate = useNavigate();
//   const location = useLocation();
//   const [Currencies, setCurrency] = useState([]);
//   const [quantities, setQuantities] = useState({});
//   const [noteQuantities, setNoteQuantities] = useState({});
//   const [fillQuantities, setFillQuantities] = useState({});
//   const [userIds, setUserId] = useState('');
//   let currency = Currency.currency.name;
//   const userId = useSelector(getUserId);
//   const [loading, setLoading] = useState(false);
//   const dispatch = useDispatch();
//   const userName = useSelector(getUserName);
//   const [Restaurants, setRestaurant] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);
//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [emp, setEmp] = useState(null);

//   const Shift = [
//     { value: '1', label: 'Morning Shift' },
//     { value: '2', label: 'Evening Shift' },
//     { value: '3', label: 'Night Shift' },
//   ];

//   useEffect(() => {
//     GetCurrency();
//     getEmployee();
//   }, []);

//   useEffect(() => {
//     const initialQuantities = {};
//     separateAndCountValues(Currencies, currency)?.forEach((item) => {
//       initialQuantities[item.value] = item.count;
//     });
//     setQuantities(initialQuantities);
//   }, [Currencies, currency]);
//   const getEmployee = async () => {
//     try {
//       const apiService = new ApiService();
//       let token = localStorage.getItem('Token');
//       let param = `?UserId=${userId}`;
//       const res = await apiService.getApiParamater('GET_EMPLOYEE', param);

//       setEmp(res?.data?.result[0]);
//     } catch (error) {
//       console.error('Error fetching Employe:', error);
//     }
//   };
//   const [formData, setFormData] = useState({
//     userName: '',
//     date: '',
//     amount: '',
//     counter: { value: '', label: '' },
//     shift: '',
//     note: '',
//     branchId: '',
//     restaurent: '',
//   });
//   const totalAmount = Object.keys(quantities).reduce((total, value) => {
//     return total + value * quantities[value];
//   }, 0);

//   const totalCashAmount = Object.keys(noteQuantities).reduce((total, value) => {
//     return total + value * noteQuantities[value];
//   }, 0);

//   const totalFills = Object.keys(fillQuantities).reduce((total, value) => {
//     return total + value * fillQuantities[value];
//   }, 0);

//   const grandTotalAmount = (parseFloat(formData?.digitalAmount || 0) + (totalAmount + totalCashAmount) + totalFills / 100).toFixed(2);

//   const CreateDayClose = async () => {
//     try {
//       const cashMeta = separateAndCountValues(Currencies, currency)
//         ?.map((item) => {
//           const coinQuantity = quantities[item.value] || 0;
//           const noteQuantity = noteQuantities[item.value] || 0;
//           const fillQuantity = fillQuantities[item.value] || 0;
//           const totalQuantity = coinQuantity + noteQuantity + fillQuantity;

//           if (totalQuantity > 0) {
//             const type = coinQuantity > 0 ? 0 : noteQuantity > 0 ? 1 : 2;

//             return {
//               currencyDenominationId: item.currencyDenominationId,
//               quantity: totalQuantity,
//               type: type,
//             };
//           }
//           return null;
//         })
//         .filter((item) => item !== null); // Filter out null items

//       const allQuantitiesZero = cashMeta.every((item) => item.quantity === 0);
//       const currentDatetime = new Date().toISOString();
//       const body = {
//         userId: userId,
//         counterId: formData?.counter.label,
//         restaurantId: emp.restaurantId,
//         branchId: emp.branchId,
//         date: currentDatetime,
//         amount: parseFloat(grandTotalAmount),
//         remarks: formData?.note || '',
//         type: CashEnums.DayClose,
//         loggedInUserId: userId,
//         cashMeta: cashMeta,
//         voucherNo: generateUniqueVoucherNumber(),
//       };
//       const apiService = new ApiService();
//       let res = await apiService.post('CREATE_CASH', body);
//       if (res?.data?.statusCode === 201) {
//         CreateShiftClose();
//       } else {
//         toast.error(res.data.message);
//       }
//     } catch (error) {
//       console.error('Error fetching Cash data:', error);
//     }
//   };
//   const CreateShiftClose = async () => {
//     try {
//       const cashMeta = separateAndCountValues(Currencies, currency)?.map((item) => ({
//         currencyDenominationId: item.currencyDenominationId,
//         quantity: quantities[item.value] || 0,
//       }));
//       const allQuantitiesZero = cashMeta.every((item) => item.quantity === 0);
//       const currentDatetime = new Date().toISOString();

//       if (allQuantitiesZero) {
//         toast.error('Please Enter Currency Denominations');
//       } else if (!formData?.branchId) {
//         toast.error('Please Enter Branch');
//       } else if (!formData?.counter) {
//         toast.error('Please Enter Counter Number');
//       } else {
//         const datareq = {
//           userId: userId,
//           counterId: parseInt(formData?.counter),
//           restaurantId: parseInt(formData?.restaurent),
//           branchId: parseInt(formData?.branchId),
//           amount: parseFloat(grandTotalAmount),
//           remarks: formData?.note || '',
//           type: CashEnums.ShiftClose,
//           loggedInUserId: userId,
//           cashMeta: cashMeta,
//           date: currentDatetime,
//           voucherNo: generateUniqueVoucherNumber(),
//         };
//         const apiService = new ApiService();
//         let res = await apiService.post('CREATE_CASH', datareq);
//         if (res?.data?.statusCode === 201) {
//           dispatch(logout());
//           // navigate('/Login')

//           localStorage.clear();
//           window.location.href = 'https://app.pro360erp.com';

//           window.location.reload(false);
//         }
//         setLoading(false);
//       }
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching Tax data:', error);
//     }
//   };
//   const GetCurrency = async () => {
//     try {
//       const apiService = new ApiService();
//       const res = await apiService.get('GET_CURRENCY');
//       setCurrency(res?.data?.result);
//     } catch (error) {
//       console.error('Error fetching currency data:', error);
//       toast.error('Error fetching currency data');
//     }
//   };
//   const separateAndCountValues = (denominations) => {
//     const filteredDenominations = denominations?.find((currency) => currency.default === true);
//     return filteredDenominations?.currencyDenomination?.map((denomination) => {
//       const count = denomination?.count || 0;
//       return {
//         currencyDenominationId: denomination?.currencyDenominationId,
//         value: denomination?.value,
//         count: count,
//         type: denomination?.type,
//       };
//     });
//   };
//   const incrementQuantity = (value, type) => {
//     if (type === 0) {
//       // Coin
//       setQuantities((prevState) => ({
//         ...prevState,
//         [value]: (prevState[value] || 0) + 1,
//       }));
//     }
//   };

//   const decrementQuantity = (value, type) => {
//     if (type === 0) {
//       // Coin
//       setQuantities((prevState) => ({
//         ...prevState,
//         [value]: Math.max((prevState[value] || 0) - 1, 0),
//       }));
//     }
//   };
//   const incrementFillQuantity = (value, type) => {
//     if (type === 2) {
//       // Coin
//       setFillQuantities((prevState) => ({
//         ...prevState,
//         [value]: (prevState[value] || 0) + 1,
//       }));
//     }
//   };

//   const decrementFillQuantity = (value, type) => {
//     if (type === 2) {
//       // Coin
//       setFillQuantities((prevState) => ({
//         ...prevState,
//         [value]: Math.max((prevState[value] || 0) - 1, 0),
//       }));
//     }
//   };

//   const incrementNoteQuantity = (value, type) => {
//     if (type === 1) {
//       // Note
//       setNoteQuantities((prevState) => ({
//         ...prevState,
//         [value]: (prevState[value] || 0) + 1,
//       }));
//     }
//   };

//   const decrementNoteQuantity = (value, type) => {
//     if (type === 1) {
//       // Note
//       setNoteQuantities((prevState) => ({
//         ...prevState,
//         [value]: Math.max((prevState[value] || 0) - 1, 0),
//       }));
//     }
//   };

//   const handleShiftChange = (selectedOption) => {
//     setFormData({ ...formData, shift: selectedOption?.value });
//   };
//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };
//   function getCurrentDate() {
//     const today = new Date();
//     let dd = today.getDate();
//     let mm = today.getMonth() + 1; //January is 0!
//     const yyyy = today.getFullYear();

//     if (dd < 10) {
//       dd = '0' + dd;
//     }

//     if (mm < 10) {
//       mm = '0' + mm;
//     }

//     return yyyy + '-' + mm + '-' + dd;
//   }
//   const handleCounterChange = (selectedOption) => {
//     setFormData({ ...formData, counter: selectedOption });
//   };
//   const cashDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 1);
//   const coinDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 0);
//   const fillDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 2);

//   return (
//     <div className="p-lg-5">
//       <div className="p-lg-5">
//         <div className="row">
//           <div className="col-lg-4 col-sm-4">
//             <form>
//               <div className="pb-lg-5">
//                 <div className="form-group row justify-content-between">
//                   <div className="col-md-6 col-lg-6">
//                     <label htmlFor="validationCustom01" className="form-label">
//                       User
//                     </label>
//                     <input type="text" className="p-2 form-control" id="validationCustom01" name="user" value={userName} disabled required />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                   <div className="col-md-6">
//                     <label htmlFor="validationCustom02" className="form-label">
//                       Shift
//                     </label>
//                     <Select
//                       styles={{
//                         menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                         option: (provided, state) => ({
//                           ...provided,
//                           backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
//                           color: state.isFocused ? '#000 ' : '#000',
//                           ':hover': {
//                             backgroundColor: '#F5F5F5',
//                             color: '#000 ',
//                           },
//                         }),
//                       }}
//                       className=""
//                       onChange={handleShiftChange}
//                       options={Shift}
//                     />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                 </div>

//                 <div className="form-group row mt-3 justify-content-between">
//                   <div className="col-md-6">
//                     <label htmlFor="validationCustom08" className="form-label">
//                       Amount
//                     </label>
//                     <input type="text" className="p-2 form-control" id="validationCustom08" name="amount" value={grandTotalAmount} required disabled />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                   <div className="col-md-6">
//                     <label htmlFor="validationCustom04" className="form-label">
//                       Date
//                     </label>
//                     <input
//                       type="date"
//                       className="p-2 form-control"
//                       id="validationCustom04"
//                       name="date"
//                       value={getCurrentDate()}
//                       required
//                       onChange={handleInputChange}
//                       disabled
//                     />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                 </div>

//                 <div className="form-group row mt-3 justify-content-between">
//                   <div className="col-md-6 col-lg-6">
//                     <label htmlFor="restaurantSelect" className="form-label">
//                       Restaurant
//                     </label>
//                     <input className="p-2 form-control" id="validationCustom08" name="restaurant" value={emp?.restaurantName} disabled />
//                   </div>
//                   <div className="col-md-6">
//                     <label htmlFor="branchSelect" className="form-label">
//                       Branch
//                     </label>
//                     <input className="p-2 form-control" id="validationCustom08" name="branch" value={emp?.branchName} disabled />
//                   </div>
//                 </div>

//                 <div className="form-group row mt-3 justify-content-between">
//                   <div className="col-md-6">
//                     <label htmlFor="validationCustom11" className="form-label">
//                       Counter
//                     </label>
//                     <Select
//                       styles={{
//                         menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                         option: (provided, state) => ({
//                           ...provided,
//                           backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
//                           color: state.isFocused ? '#fff ' : '#fff',
//                           ':hover': {
//                             backgroundColor: '#F5F5F5',
//                             color: '#ffff ',
//                           },
//                         }),
//                       }}
//                       type="number"
//                       id="validationCustom08"
//                       name="counter"
//                       value={formData.counter}
//                       placeholder="Select Counter"
//                       onChange={(selectedOption) => handleCounterChange(selectedOption)} // Pass the entire object to the function
//                       options={emp?.counters?.map((count) => ({ value: count?.counterId, label: count.counterName }))}
//                       required
//                     />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                   <div className="col-md-6 col-lg-6">
//                     <label htmlFor="validationCustom06" className="form-label">
//                       Note
//                     </label>
//                     <textarea
//                       type="text"
//                       className="p-2 form-control"
//                       id="validationCustom06"
//                       name="note"
//                       value={formData.note}
//                       onChange={handleInputChange}
//                       required
//                     />
//                     <div className="valid-feedback">Looks good!</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="row mt-5">
//                 <div className="end">
//                   <div className="addItem-btn" onClick={() => CreateDayClose()}>
//                     Save
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//           {cashDenominations?.length === 0 ? (
//             ' '
//           ) : (
//             <div className="col">
//               <div className="">
//                 <div>Cash Denominations</div>
//                 <div className="borderMain mt-3 p-4">
//                   {cashDenominations?.map((item, index) => (
//                     <div className="row p-2 my-3 innerBorder" key={index}>
//                       <div className="col-3">{item.value} X</div>
//                       <div className="col-6 d-flex justify-content-between">
//                         <div className="vr"></div>
//                         <div className="quantity-control d-flex justify-content-around center">
//                           <div onClick={() => decrementNoteQuantity(item.value, item?.type)} className="addbtn center">
//                             -
//                           </div>
//                           <div className="center px-2">{noteQuantities[item.value] || 0}</div>
//                           <div onClick={() => incrementNoteQuantity(item.value, item?.type)} className="addbtn center">
//                             +
//                           </div>
//                         </div>
//                         <div className="vr"></div>
//                       </div>
//                       <div className="col-3">{item.value * (noteQuantities[item.value] || 0)}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}
//           {coinDenominations?.length === 0 ? (
//             ' '
//           ) : (
//             <div className="col">
//               <div className="">
//                 <div>Coin Denominations</div>
//                 <div className="borderMain mt-3 p-4">
//                   {coinDenominations?.map((item, index) => (
//                     <div className="row p-2 my-3 innerBorder" key={index}>
//                       <div className="col-3">{item.value} X</div>
//                       <div className="col-6 d-flex justify-content-between">
//                         <div className="vr"></div>
//                         <div className="quantity-control d-flex justify-content-around center">
//                           <div onClick={() => decrementQuantity(item.value, item?.type)} className="addbtn center">
//                             -
//                           </div>
//                           <div className="center px-2">{quantities[item.value] || 0}</div>
//                           <div onClick={() => incrementQuantity(item.value, item?.type)} className="addbtn center">
//                             +
//                           </div>
//                         </div>
//                         <div className="vr"></div>
//                       </div>
//                       <div className="col-3">{item.value * (quantities[item.value] || 0)}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}
//           {fillDenominations?.length === 0 ? (
//             ' '
//           ) : (
//             <div className="col">
//               <div className="">
//                 <div>Fill Denominations</div>
//                 <div className="borderMain mt-3 p-4">
//                   {fillDenominations?.map((item, index) => (
//                     <div className="row p-2 my-3 innerBorder" key={index}>
//                       <div className="col-3">{item.value} X</div>
//                       <div className="col-6 d-flex justify-content-between">
//                         <div className="vr"></div>
//                         <div className="quantity-control d-flex justify-content-around center">
//                           <div onClick={() => decrementFillQuantity(item.value, item?.type)} className="addbtn center">
//                             -
//                           </div>
//                           <div className="center px-2">{fillQuantities[item.value] || 0}</div>
//                           <div onClick={() => incrementFillQuantity(item.value, item?.type)} className="addbtn center">
//                             +
//                           </div>
//                         </div>
//                         <div className="vr"></div>
//                       </div>
//                       <div className="col-3">{item.value * (fillQuantities[item.value] || 0)}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const mapStatetoProps = (state) => state;
// export default connect(mapStatetoProps)(DayCloseForm);

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../pages/cashierMenu.css';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import userManagement from '../../../services/userManagement';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getUserId, getUserName } from '../../../../Redux/selecters';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { logout } from '../../../../Redux/actions';
import { CashEnums } from '../../../../Enums/config';
import { generateUniqueVoucherNumber } from '../.../../../../services/globalService';

const DayCloseForm = ({ Currency }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const [Currencies, setCurrency] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [noteQuantities, setNoteQuantities] = useState({});
  const [fillQuantities, setFillQuantities] = useState({});
  const [userIds, setUserId] = useState('');
  let currency = Currency.currency.name;
  const userId = useSelector(getUserId);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const userName = useSelector(getUserName);
  const [Restaurants, setRestaurant] = useState([]);
  const [branches, setBranches] = useState([]);
  const [Counter, setCounter] = useState();

  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [emp, setEmp] = useState(null);

  // NEW: hold counter from localStorage
  const [counterInfo, setCounterInfo] = useState(null);

  const Shift = [
    { value: '1', label: 'Morning Shift' },
    { value: '2', label: 'Evening Shift' },
    { value: '3', label: 'Night Shift' },
  ];

  useEffect(() => {
    GetCurrency();
    getEmployee();
    let counter = localStorage.getItem('Counter');

    setCounter(JSON.parse(counter));
  }, []);

  // Read Counter from localStorage and prefill the Select value
  useEffect(() => {
    try {
      const stored = localStorage.getItem('Counter');
      if (stored) {
        const parsed = JSON.parse(stored);
        setCounterInfo(parsed);
        setFormData((prev) => ({
          ...prev,
          counter: { value: parsed?.counterId, label: parsed?.counterName },
        }));
      }
    } catch (e) {
      console.error('Failed to parse Counter from localStorage', e);
    }
  }, []);

  useEffect(() => {
    const initialQuantities = {};
    separateAndCountValues(Currencies, currency)?.forEach((item) => {
      initialQuantities[item.value] = item.count;
    });
    setQuantities(initialQuantities);
  }, [Currencies, currency]);

  const getEmployee = async () => {
    try {
      const apiService = new ApiService();
      let token = localStorage.getItem('Token');
      let param = `?UserId=${userId}`;
      const res = await apiService.getApiParamater('GET_EMPLOYEE', param);
      debugger;
      setEmp(res?.data?.result[0]);
    } catch (error) {
      console.error('Error fetching Employe:', error);
    }
  };

  const [formData, setFormData] = useState({
    userName: '',
    date: '',
    amount: '',
    counter: { value: '', label: '' }, // will be set from localStorage if present
    shift: '',
    note: '',
    branchId: '',
    restaurent: '',
    digitalAmount: 0, // NEW: avoid NaN in total calc
  });

  const sumFrom = (mapObj) =>
    Object.entries(mapObj).reduce((total, [val, qty]) => {
      const v = Number(val);
      const q = Number(qty) || 0;
      if (!Number.isFinite(v)) return total; // skip bad keys
      return total + v * q;
    }, 0);

  const totalAmount = sumFrom(quantities);
  const totalCashAmount = sumFrom(noteQuantities);
  const totalFillsRaw = sumFrom(fillQuantities);
  const totalFills = totalFillsRaw; // keep your existing intent
  const grandTotalAmount = ((Number(formData?.digitalAmount) || 0) + totalAmount + totalCashAmount + totalFills).toFixed(2);

  const CreateDayClose = async () => {
    try {
      const cashMeta = separateAndCountValues(Currencies, currency)
        ?.map((item) => {
          const coinQuantity = quantities[item.value] || 0;
          const noteQuantity = noteQuantities[item.value] || 0;
          const fillQuantity = fillQuantities[item.value] || 0;
          const totalQuantity = coinQuantity + noteQuantity + fillQuantity;

          if (totalQuantity > 0) {
            const type = coinQuantity > 0 ? 0 : noteQuantity > 0 ? 1 : 2;

            return {
              currencyDenominationId: item.currencyDenominationId,
              value: totalQuantity,
              type: type,
              daySessionId: Counter?.shiftId || Counter?.dayId,
              sessionType: 0,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      const currentDatetime = new Date().toISOString();
      const counterIdToSend = counterInfo?.counterId ?? formData?.counter?.value ?? null;

      // if (!emp?.restaurantId || !emp?.branchId) {
      //   toast.error('Restaurant/Branch not found for user.');
      //   return;
      // }
      if (!counterIdToSend) {
        toast.error('Counter not found.');
        return;
      }

      const body = {
        userId: userId,
        counterId: counterIdToSend, // FIXED: send numeric ID
        restaurantId: emp.restaurantId,
        branchId: emp.res_Branch_Id,
        date: currentDatetime,
        amount: parseFloat(grandTotalAmount),
        remarks: formData?.note || '',
        type: CashEnums.DayClose,
        loggedInUserId: userId,
        closedBy: emp?.id || 0,
        cashMeta: cashMeta,
        voucherNo: generateUniqueVoucherNumber(),
      };
      debugger;
      const apiService = new ApiService();
      let res = await apiService.post('CLOSE_DAY', body);
      if (res?.data?.statusCode === 201 || res?.data?.statusCode === 200) {
        callDayClose();
      } else {
        toast.error(res?.data?.message || 'Failed to create Day Close');
      }
    } catch (error) {
      console.error('Error fetching Cash data:', error);
      toast.error('Error while creating Day Close');
    }
  };

  const callDayClose = async () => {
    try {
      const counterRaw = localStorage.getItem('Counter');
      if (!counterRaw) {
        toast.error('Counter not found in localStorage.');
        return;
      }
      const counter = JSON.parse(counterRaw);

      // Build denominations from your existing state/helpers
      const denoms = separateAndCountValues(Currencies, currency) || [];

      const asTotalLine = (faceValue, qty, type, currencyDenominationId) => ({
        currencyId: currencyDenominationId, // your data exposes currencyDenominationId; map to currencyId for API
        value: Number(faceValue) * Number(qty || 0), // total value for that line
        type, // 0 coin, 1 note, 2 fill
        sessionType: Number(counter?.shiftId) || 0,
        daySessionId: Number(counter?.dayId) || 0,
        shiftSessionId: Number(counter?.shiftId) || 0,
      });

      const currencyDenomination = [];

      denoms.forEach((d) => {
        const face = d.value;
        if (d.type === 0) {
          const qty = Number(quantities[face] || 0);
          if (qty > 0) currencyDenomination.push(asTotalLine(face, qty, 0, d.currencyDenominationId));
        }
        if (d.type === 1) {
          const qty = Number(noteQuantities[face] || 0);
          if (qty > 0) currencyDenomination.push(asTotalLine(face, qty, 1, d.currencyDenominationId));
        }
        if (d.type === 2) {
          const qty = Number(fillQuantities[face] || 0);
          if (qty > 0) currencyDenomination.push(asTotalLine(face, qty, 2, d.currencyDenominationId));
        }
      });

      if (currencyDenomination.length === 0) {
        toast.error('Please enter currency denominations.');
        return;
      }

      const body = {
        dayId: Number(counter?.dayId) || 0,
        openedBy: Number(userId) || 0,
        closedBy: Number(userId) || 0,
        openDateTime: counter?.counterOpenTime || new Date().toISOString(),
        closeDateTime: new Date().toISOString(),
        status: 'Closed',
        currencyDenomination,
        shiftId: Number(counter?.shiftId) || 0,
        counterId: Number(counter?.counterId) || 0,
      };
      debugger;
      const api = new ApiService();
      const res = await api.put('CLOSE_DAY', body); // <-- use your actual route key
      if (res?.status === 201 || res?.status === 200) {
        toast.success('Day closed successfully.');
        dispatch(logout());
        localStorage.clear();
        // navigate('/login');
        window.location.href = 'https://app.pro360erp.com';
        window.location.reload(false);
      } else {
        toast.error(res?.message || 'Failed to close the day.');
      }
    } catch (e) {
      console.error(e);
      toast.error('Error while closing the day.');
    }
  };

  const GetCurrency = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_CURRENCY');
      setCurrency(res?.data?.result);
    } catch (error) {
      console.error('Error fetching currency data:', error);
      toast.error('Error fetching currency data');
    }
  };

  const separateAndCountValues = (denominations) => {
    const filteredDenominations = denominations?.find((c) => c.default === true);

    return filteredDenominations?.currencyDenomination
      ?.filter((d) => Number.isFinite(Number(d?.value))) // <- drop null/NaN values
      ?.map((denomination) => {
        const count = denomination?.count || 0;
        return {
          currencyDenominationId: denomination?.currencyDenominationId,
          value: Number(denomination?.value), // <- normalize to number
          count,
          type: denomination?.type,
        };
      });
  };

  const incrementQuantity = (value, type) => {
    if (type === 0) {
      setQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementQuantity = (value, type) => {
    if (type === 0) {
      setQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  const incrementFillQuantity = (value, type) => {
    if (type === 2) {
      setFillQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementFillQuantity = (value, type) => {
    if (type === 2) {
      setFillQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  const incrementNoteQuantity = (value, type) => {
    if (type === 1) {
      setNoteQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementNoteQuantity = (value, type) => {
    if (type === 1) {
      setNoteQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  const handleShiftChange = (selectedOption) => {
    setFormData({ ...formData, shift: selectedOption?.value });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  function getCurrentDate() {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return yyyy + '-' + mm + '-' + dd;
  }

  const handleCounterChange = (selectedOption) => {
    // Not used since Select is disabled, but kept for completeness
    setFormData({ ...formData, counter: selectedOption });
  };

  const cashDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 1);
  const coinDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 0);
  const fillDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 2);

  return (
    <div className="p-lg-5">
      <div className="p-lg-5">
        <div className="row">
          <div className="col-lg-4 col-sm-4">
            <form>
              <div className="pb-lg-5">
                <div className="form-group row justify-content-between">
                  <div className="col-md-6 col-lg-6">
                    <label htmlFor="validationCustom01" className="form-label">
                      User
                    </label>
                    <input type="text" className="p-2 form-control" id="validationCustom01" name="user" value={userName} disabled required />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                  {/* <div className="col-md-6">
                                        <label htmlFor="validationCustom02" className="form-label">Shift</label>
                                        <Select styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                            className=''
                                            onChange={handleShiftChange}
                                            options={Shift}
                                        />
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                    </div> */}
                  <div className="col-md-6">
                    <label htmlFor="validationCustom11" className="form-label">
                      Counter
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      type="number"
                      id="validationCustom08"
                      name="counter"
                      value={formData.counter}
                      placeholder="Select Counter"
                      onChange={(selectedOption) => handleCounterChange(selectedOption)} // Pass the entire object to the function
                      options={emp?.counters?.map((count) => ({ value: count?.counterId, label: count.counterName }))}
                      required
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>

                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-6">
                    <label htmlFor="validationCustom08" className="form-label">
                      Amount
                    </label>
                    <input type="text" className="p-2 form-control" id="validationCustom08" name="amount" value={grandTotalAmount} required disabled />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="validationCustom04" className="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      className="p-2 form-control"
                      id="validationCustom04"
                      name="date"
                      value={getCurrentDate()}
                      required
                      onChange={handleInputChange}
                      disabled
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>

                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-6 col-lg-6">
                    <label htmlFor="restaurantSelect" className="form-label">
                      Company
                    </label>
                    <input className="p-2 form-control" id="validationCustom08" name="restaurant" value={emp?.restaurantName || ''} disabled />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="branchSelect" className="form-label">
                      Branch
                    </label>
                    <input className="p-2 form-control" id="validationCustom08" name="branch" value={emp?.branchName || ''} disabled />
                  </div>
                </div>

                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-6">
                    <label htmlFor="validationCustom11" className="form-label">
                      Counter
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#fff ' : '#fff',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#ffff ',
                          },
                        }),
                      }}
                      id="validationCustom08"
                      name="counter"
                      disabled
                      value={formData.counter}
                      placeholder="Select Counter"
                      onChange={(selectedOption) => handleCounterChange(selectedOption)}
                      options={emp?.counters?.map((count) => ({ value: count?.counterId, label: count.counterName })) || []}
                      required
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <label htmlFor="validationCustom06" className="form-label">
                      Note
                    </label>
                    <textarea
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom06"
                      name="note"
                      value={formData.note}
                      onChange={handleInputChange}
                      required
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="end">
                  <div className="addItem-btn" onClick={callDayClose}>
                    {loading ? 'Saving…' : 'Save'}
                  </div>
                </div>
              </div>
            </form>
          </div>

          {cashDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Cash Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {cashDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementNoteQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{noteQuantities[item.value] || 0}</div>
                          <div onClick={() => incrementNoteQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{item.value * (noteQuantities[item.value] || 0)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {coinDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Coin Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {coinDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{quantities[item.value] || 0}</div>
                          <div onClick={() => incrementQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{item.value * (quantities[item.value] || 0)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {fillDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Cents Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {fillDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementFillQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{fillQuantities[item.value] || 0}</div>
                          <div onClick={() => incrementFillQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{(item.value * (fillQuantities[item.value] || 0)).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(DayCloseForm);
